import { render, staticRenderFns } from "./AddOnCharge.vue?vue&type=template&id=b0f2ceea&"
import script from "./AddOnCharge.vue?vue&type=script&lang=js&"
export * from "./AddOnCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports